'use client';

import Image from 'next/image';
import Link from 'next/link';
import InstagramIcon from '../../icons/InstagramIcon';
import React from 'react';
import { Button } from './Button';
import { gtag_report_conversion } from '@/app/gtag';

export function HeaderClient() {
  return (
    <header className="w-full flex justify-center bg-primary lg:bg-[#1D2738]">
      <div className="w-full lg:px-4 lg:py-8 bg-primary lg:bg-[#1D2738] max-w-7xl">
        <div className="flex justify-between p-5 lg:hidden">
          <Link href="/" className="cursor-pointer">
            <Image
              src="/logo-jb-primary.svg"
              alt="Escritório de advocacia John Bihuna em Biguaçu, SC"
              width={150}
              height={48}
              fetchPriority="high"
              className="w-auto h-[48px]"
            />
          </Link>
          <a
            href="https://instagram.com/johnbihuna.adv"
            target="_blank"
            rel="noopener noreferrer"
            className="group border-2 border-secondary min-w-12 min-h-12 rounded-full p-2 flex justify-center items-center fill-secondary hover:bg-[#CFA969] transition-colors"
            aria-label="Instagram"
          >
            <InstagramIcon className="fill-inherit group-hover:fill-white transition-colors" />
          </a>
        </div>
        <div className="hidden lg:flex lg:justify-between lg:items-center lg:px-16 lg:py-4 lg:rounded-xl lg:bg-primary">
          <Link href="/" className="cursor-pointer">
            <Image
              src="/logo-jb-primary.svg"
              alt="Escritório de advocacia John Bihuna em Biguaçu, SC"
              width={220}
              height={60}
              fetchPriority="high"
              className="w-auto h-[60px]"
            />
          </Link>
          <Button
            component="a"
            href="https://instagram.com/johnbihuna.adv"
            target="_blank"
            variant="outline"
            icon={<InstagramIcon />}
          >
            VISITE O NOSSO INSTAGRAM
          </Button>
        </div>
        <hr className="w-full border-[#FFFFFF05] border-b lg:border-none" />
      </div>
    </header>
  );
}
